import { useEffect } from 'react';
import { usePrescriptionStore } from '../stores/prescriptionStore';
import { get } from 'lodash';

declare global {
  interface Window {
    hj?: any;
    _hjSettings?: any;
  }
}

export const useHotjar = () => {
  const prescriberConfiguration = usePrescriptionStore((store) => store.prescriberConfiguration);

  useEffect(() => {
    const isHotjarActive = get(prescriberConfiguration, 'Features.enableHotjar', false);

    if (!isHotjarActive || (window as any).hj) {
      return;
    }

    (function(h: any, o: Document, t: string, j: string, a: HTMLElement | null, r: HTMLScriptElement) {
      h.hj = h.hj || function() { 
        (h.hj.q = h.hj.q || []).push(arguments); 
      };
      h._hjSettings = { hjid: 6556724, hjsv: 6 };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = true;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=', null as any, null as any);

  }, [prescriberConfiguration]);
};

